import React, { useState, useContext, useEffect } from 'react';
import 'antd/dist/antd.css';
import { Form, Input, Button, Checkbox, notification, message, Tabs } from 'antd';
import poster from '../files-img-video/poster.jpg';
import videos from '../files-img-video/wallhaven.mp4';
import { getLogin, API, forgotPassword, hostDomain } from '../api/api';
import { ContextData } from '../../context/Data/ContextData';
import { ArrowLeftOutlined } from '@ant-design/icons';
const Login = () => {
  const test: any = videos;
  const { TabPane } = Tabs;
  const { data, setData } = useContext(ContextData);
  const [regData, setRegData] = useState(false);
  const [isPasswordReset, setIsPasswordReset] = useState(true);

  useEffect(() => {
    if (typeof localStorage.access_token !== 'undefined' && localStorage.access_token !== null) {
      setData(true);
    }
  }, []);
  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };
  const onFinish = (values: any) => {
    if (isPasswordReset) {
      const catchError = (error: any) => {
        notification.open({ message: 'Неверный пароль' });
        message.error('Неверный пароль');
      };
      getLogin(values.email, values.password)
        .then((res) => {
          if (res.error == 'Unauthorized') {
            catchError(res);
          } else if (res.error === 'Не хватает прав') {
            notification.open({ message: 'Вас не подтвердили в системе' });
          } else if (res.access_token) {
            notification.open({ message: 'Успешно' });

            setData(true);
          }
        })
        .catch(catchError);
    } else {
      forgotPassword(values).then((res: any) => {
        res.status === 500
          ? notification.open({ message: res.message + '\nОшибка: ' + res.error })
          : notification.open({ message: res.message });
      });
    }
  };
  const swapReg = (param: any) => {
    setRegData(param);
  };
  const registerLogin = (values: any) => {
    // getRegistration(values.email, values.password, values.name)
    API.regPostFun(values.email, values.password, values.name)
      .then((res: any) => {
        if (res.ok === false && res.status === 500) {
          notification.open({ message: 'Вы уже зарегистрированы' });
        } else if (res.ok === true && res.status === 201) {
          notification.open({ message: 'Регистрация успешна' });
          swapReg(true);
        }
      })
      .catch(() => {
        notification.open({ message: 'Упс что-то пошло не так' });
      });
  };
  const changeTabpaneToResetPassword = () => {
    isPasswordReset ? setIsPasswordReset(false) : setIsPasswordReset(true);
  };

  return (
    <>
      <div className="login__wrapper">
        <img
          src="https://static.tildacdn.com/tild3061-6639-4964-b664-353665643661/GCG.png"
          className="img__logo"
          alt=""
        />
        <video
          className="login-video"
          poster={poster}
          muted={true}
          loop
          autoPlay={true}
          src={videos}
        ></video>
        <div className="login__from-wrapper">
          <Tabs type="card">
            <Tabs.TabPane tab="Вход" key="1">
              {isPasswordReset ? (
                <Form
                  name="basic"
                  labelCol={{
                    span: 8,
                  }}
                  wrapperCol={{
                    span: 16,
                  }}
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                >
                  <Form.Item
                    label="Email"
                    // initialValue={'aa@aa.aa'}
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: 'Не валидный Email',
                        type: 'email',
                      },
                    ]}
                  >
                    {/* <Input defaultValue={'zemfira_it_online@vtorf.ru'} /> */}
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label="Пароль"
                    name="password"
                    // initialValue={'ZZss11!!'}
                    rules={[
                      {
                        required: true,
                        message: 'пожалуйста введите пароль!',
                      },
                    ]}
                  >
                    <Input.Password />
                    {/* <Input.Password defaultValue={'ZemaZema'} /> */}
                  </Form.Item>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Form.Item
                      name="remember"
                      valuePropName="checked"
                      wrapperCol={{
                        offset: 1,
                        span: 16,
                      }}
                    >
                      <Checkbox>Запомнить пароль</Checkbox>
                    </Form.Item>
                    <a onClick={changeTabpaneToResetPassword}>Забыли пароль?</a>
                  </div>
                  <Form.Item
                    wrapperCol={{
                      offset: 8,
                      span: 16,
                    }}
                  >
                    <Button type="primary" htmlType="submit">
                      Авторизация
                    </Button>
                  </Form.Item>
                </Form>
              ) : (
                <Form
                  name="basic"
                  labelCol={{
                    span: 8,
                  }}
                  wrapperCol={{
                    span: 16,
                  }}
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                >
                  <ArrowLeftOutlined onClick={changeTabpaneToResetPassword} />
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: 'Не валидный Email',
                        type: 'email',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Button
                    style={{ width: '100%', marginTop: '40%' }}
                    type="primary"
                    htmlType="submit"
                  >
                    Отправить письмо
                  </Button>
                </Form>
              )}
            </Tabs.TabPane>

            <TabPane tab="Регистрация" key="2">
              {regData ? (
                <> Регистрация Успешна</>
              ) : (
                <Form
                  name="registerLogin"
                  labelCol={{
                    span: 8,
                  }}
                  wrapperCol={{
                    span: 16,
                  }}
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={registerLogin}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                >
                  <Form.Item
                    label="Ф И О"
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: 'пожалуйста заполните полепа',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: 'Не валидный Email',
                        type: 'email',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Пароль"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: 'пожалуйста введите пароль!',
                      },
                    ]}
                  >
                    <Input.Password />
                  </Form.Item>
                  <Form.Item
                    name="remember"
                    valuePropName="checked"
                    wrapperCol={{
                      offset: 8,
                      span: 16,
                    }}
                  ></Form.Item>

                  <Form.Item
                    style={{ width: '100%' }}
                    wrapperCol={{
                      offset: 8,
                      span: 16,
                    }}
                  >
                    <Button type="primary" htmlType="submit">
                      Авторизация
                    </Button>
                  </Form.Item>
                </Form>
              )}
            </TabPane>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default Login;
